import styled from '@emotion/styled';

export const Container = styled.div`
    padding: 2rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
`;
export const ToggleRecordButton = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    border: none;
    border-radius: 50%;
    background-color: ${({ isRecording, isConnectingSocket, disabled }) =>
        isConnectingSocket || disabled ? '#d8d5d5' : isRecording ? '#ea9941' : '#50aeb0'};
    color: white;
    cursor: pointer;
    font-weight: 600;
    font-size: 20px;
    margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
    box-shadow: ${({ isRecording }) => (isRecording ? '0 0 12px 3px rgba(230, 57, 70, 0.6)' : 'none')};
    animation: ${({ isRecording }) => (isRecording ? 'pulse 1.4s infinite' : 'none')};
    transition:
        background 0.3s,
        box-shadow 0.3s;

    @keyframes pulse {
        0% {
            box-shadow: 0 0 0 0 rgba(255, 165, 0, 0.6);
        }
        70% {
            box-shadow: 0 0 0 24px rgba(255, 165, 0, 0);
        }
        100% {
            box-shadow: 0 0 0 0 rgba(255, 165, 0, 0);
        }
    }
`;
export const PartialTextPreviewBox = styled.textarea`
    background-color: #f1f1f1;
    padding: 10px;
    border-radius: 5px;
    margin-top: 18px;
    border: none;
    height: ${({ height }) => height || 'auto'}px;
    min-width: 500px;
    min-height: 300px;
`;
